import apiClient from "@/api/client";

export interface OrphanInDB {
  db_id: number;
  vmid: number;
  name: string;
  node: string;
  db_status: string;
}

export interface OrphanInProxmox {
  node: string;
  vmid: number;
  name: string;
  pve_status: string;
}

export interface StatusDrift {
  db_id: number;
  vmid: number;
  name: string;
  node: string;
  db_status: string;
  pve_status: string;
}

export interface ReconciliationReport {
  scanned_at: string;
  nodes: string[];
  orphans_in_db: OrphanInDB[];
  orphans_in_proxmox: OrphanInProxmox[];
  drifts: StatusDrift[];
  errors: string[];
  total_issues: number;
}

export async function getReconciliationReport(): Promise<ReconciliationReport> {
  const { data } = await apiClient.get<ReconciliationReport>(
    "/admin/reconciliation/orphans",
  );
  return data;
}

export async function softDeleteOrphanDB(vmId: number): Promise<void> {
  await apiClient.post(`/admin/reconciliation/orphans-in-db/${vmId}/soft-delete`);
}

export async function importOrphanProxmox(
  node: string,
  vmid: number,
  payload: { tenant_id: number; service_tier?: "A" | "B" | "C" },
): Promise<{ id: number; vmid: number; name: string }> {
  const { data } = await apiClient.post(
    `/admin/reconciliation/orphans-in-proxmox/${node}/${vmid}/import`,
    payload,
  );
  return data;
}

export async function destroyOrphanProxmox(
  node: string,
  vmid: number,
): Promise<void> {
  await apiClient.post(
    `/admin/reconciliation/orphans-in-proxmox/${node}/${vmid}/destroy`,
  );
}

export async function syncDrift(
  vmId: number,
): Promise<{ id: number; vmid: number; status: string }> {
  const { data } = await apiClient.post(
    `/admin/reconciliation/drift/${vmId}/sync`,
  );
  return data;
}
